import { render, staticRenderFns } from "./StatGroups.vue?vue&type=template&id=05c89b28"
import script from "./StatGroups.vue?vue&type=script&lang=js"
export * from "./StatGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports